export default "__VITE_ASSET__BuCHB6Qh__"